import { environmentHttpClient } from "client/Api/httpClient";

export enum ImportTarget {
	No = 0,
	Workspace365 = 1
};

export type Office365GroupModel = {
	id: string;
	name: string;
};

export type Office365User = {
	firstName: string;
	lastName: string;
	userPrincipalName: string;
	primaryEmailAddress: string | null;
	title: string;
	phoneNumber: string;
};

export type UserImportModel = {
	firstName: string;
	lastName: string;
	jobTitle: string;
	emailAddress: string | null;
	userPrincipalName: string;
	mobilePhone: string;
};

export type ImportFromUserGroupsResult = {
	failedUsers: FailedToImportUserModel[];
};

export type FailedToImportUserModel = {
	email: string;
	importError: ImportError;
};

export type ImportUserResult = {
	rowNumber: number;
	userPrincipalName: string;
	outcome: IImportUserOutcome;
};

export type IImportUserOutcome = SuccessfullyImported | ImportedWithWarnings | ImportError;

export enum ResultType {
	Error = 0,
	Warning = 1,
	Success = 2
}

export type SuccessfullyImported = {
	type: ResultType.Success;
};

export type ImportedWithWarnings = {
	type: ResultType.Warning;
	message: string;
};

export type ImportError = {
	type: ResultType.Error;
	errors: ClientValidationErrorModel[];
};

export type ClientValidationErrorModel = {
	propertyName: string;
	errorMessage: string;
};

export function getViewModel(
	signal?: AbortSignal
): Promise<ImportTarget> {
	return environmentHttpClient.get<ImportTarget>(
		"UiApi/ImportUsers",
		undefined,
		{ signal }
	);
}

export function getOffice365UsersWhichDoNotExistInTheWorkspace(
	signal?: AbortSignal
): Promise<readonly Office365User[]> {
	return environmentHttpClient.get<readonly Office365User[]>(
		"UiApi/ImportUsers/GetOffice365UsersWhichDoNotExistInTheWorkspace",
		undefined,
		{ signal }
	);
}

export function importUsersToWorkspace(
	batch: readonly UserImportModel[],
	signal?: AbortSignal
): Promise<readonly ImportUserResult[]> {
	return environmentHttpClient.post<readonly ImportUserResult[]>(
		"UiApi/ImportUsers/ImportUsersToWorkspace",
		batch,
		{ signal }
	);
}

export function importFromOffice365Groups(
	selectedGroupIds: string[],
	signal?: AbortSignal
): Promise<ImportFromUserGroupsResult> {
	return environmentHttpClient.post<ImportFromUserGroupsResult>(
		"UiApi/ImportUsers/ImportFromOffice365Groups",
		{
			groupIds: selectedGroupIds
		},
		{ signal }
	);
}

export function getOffice365Groups(
	signal?: AbortSignal
): Promise<readonly Office365GroupModel[]> {
	return environmentHttpClient.get<readonly Office365GroupModel[]>(
		"UiApi/ImportUsers/Office365Groups",
		undefined,
		{ signal }
	);
}